var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemovePendingState = function SvgRemovePendingState(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 4.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 31.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.558 9C35.1052 11.4627 36 14.3769 36 17.5C36 21.5578 34.4895 25.2628 32 28.0833",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16309 11.5C7.53664 5.63634 13.2853 1.5 20.0001 1.5C21.2023 1.5 22.3736 1.6326 23.5001 1.88397",
    stroke: "#B2B5B2",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16309 23.5001C7.53667 29.3637 13.2853 33.5 20 33.5C20.3784 33.5 20.7537 33.4868 21.1255 33.461",
    stroke: "#B2B5B2",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 22.0064C19.0353 22.0064 19.3333 21.7084 19.3333 21.3398V17.3398C19.3333 16.9711 19.0353 16.6731 18.6667 16.6731C18.298 16.6731 18 16.9711 18 17.3398V21.3398C18 21.7084 18.298 22.0064 18.6667 22.0064Z",
    fill: "#B2B5B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3341 22.0064C21.7028 22.0064 22.0008 21.7084 22.0008 21.3398V17.3398C22.0008 16.9711 21.7028 16.6731 21.3341 16.6731C20.9655 16.6731 20.6675 16.9711 20.6675 17.3398V21.3398C20.6675 21.7084 20.9655 22.0064 21.3341 22.0064Z",
    fill: "#B2B5B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0085 23.0338C22.9998 23.2032 22.8365 23.3358 22.6771 23.3345H17.3125C17.1591 23.3172 17.0051 23.2038 16.9965 23.0292L16.5645 15.3332H23.4225L23.0085 23.0338ZM18.6644 13.0772C18.6644 12.8545 18.8531 12.6665 19.0757 12.6665H20.9211C21.1477 12.6665 21.3324 12.8512 21.3324 13.0772V13.9998H18.6644V13.0772ZM25.3328 13.9998H24.1742C24.1702 13.9998 24.1662 13.9965 24.1615 13.9965C24.1535 13.9958 24.1468 13.9998 24.1382 13.9998H22.6655V13.0771C22.6655 12.1158 21.8835 11.3331 20.9208 11.3331H19.0755C18.1135 11.3331 17.3308 12.1158 17.3308 13.0771V13.9998H14.6662C14.2982 13.9998 13.9995 14.2978 13.9995 14.6665C13.9995 15.0351 14.2982 15.3331 14.6662 15.3331H15.2295L15.6648 23.0978C15.7068 23.9711 16.4388 24.6685 17.2915 24.6685C17.3035 24.6685 17.3155 24.6678 17.3275 24.6678H22.6608H22.6988C23.5655 24.6678 24.2982 23.9718 24.3402 23.1025L24.7575 15.3331H25.3328C25.7015 15.3331 25.9995 15.0351 25.9995 14.6665C25.9995 14.2978 25.7015 13.9998 25.3328 13.9998Z",
    fill: "#B2B5B2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemovePendingState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-pending-state.f6da023c.svg";
export { ForwardRef as ReactComponent };